<ng-container *ngIf="costAccountingState$ | async as state">

    <div class="header">
        <mat-form-field>
            <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </div>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="costCt" matSortDirection="asc">
        <ng-container matColumnDef="costType.name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.component.cost-type-cost.cost-type.label" | translate }}</th>
            <td mat-cell *matCellDef="let costTypeCost">
                {{costTypeCost.costType.name}}
            </td>
        </ng-container>

        <ng-container matColumnDef="costCt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.component.cost-type-cost.costCt.label" | translate }}</th>
            <td mat-cell *matCellDef="let costTypeCost">
                {{costTypeCost.costCt / 100 | number: '1.2-2' : 'de-DE' }} €
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="layout.costTypeCostColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let costTypeCost; columns: layout.costTypeCostColumns;"></tr>

    </table>

</ng-container>
